/* eslint-disable no-undef */
import { api } from "@/lib/api";

const SW_PATH = "/sw.js";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) out[i] = raw.charCodeAt(i);
  return out;
}

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window;

export async function ensureRegistration() {
  if (!pushSupported()) return null;
  let reg = await navigator.serviceWorker.getRegistration();
  if (!reg) reg = await navigator.serviceWorker.register(SW_PATH);
  await navigator.serviceWorker.ready;
  return reg;
}

export async function getCurrentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function subscribePush() {
  if (!pushSupported()) throw new Error("Push not supported on this device.");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications denied.");
  const reg = await ensureRegistration();
  const { data: keyResp } = await api.get("/push/vapid-public-key");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(keyResp.key),
  });
  await api.post("/push/subscribe", { subscription: sub.toJSON(), enabled: true });
  return sub;
}

export async function unsubscribePush() {
  const sub = await getCurrentSubscription();
  if (!sub) return true;
  await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
  await sub.unsubscribe();
  return true;
}

export async function testPush() {
  const { data } = await api.get("/push/test");
  return data;
}
